/**
 * ERC Undriven Net Validator Adapter for DRC System
 *
 * This validator checks for nets with input pins but no driver pins.
 *
 * Feature-gated via DrcEnabledCheckers.ErcUndrivenNetValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
import { isPinDriver, pinRequiresDriver, getPinTypeName } from "../pinTypes";
import { getPinsForNet, createErcProblem, formatPinReference } from "./ercUtils";
/**
 * Validator that checks for nets without any driver.
 */
export class ErcUndrivenNetValidator {
    reviewType = ReviewType.DesignRuleCheckErcUndrivenNet;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(inputs) {
        const foundProblems = [];
        for (const [netHash, terminals] of Object.entries(inputs.netMap)) {
            const pins = getPinsForNet(inputs, terminals);
            if (pins.length === 0) {
                continue;
            }
            const pinsRequiringDriver = [];
            let hasDriver = false;
            for (const pin of pins) {
                if (isPinDriver(pin.pinType)) {
                    hasDriver = true;
                }
                if (pinRequiresDriver(pin.pinType)) {
                    pinsRequiringDriver.push(pin);
                }
            }
            if (pinsRequiringDriver.length > 0 && !hasDriver) {
                for (const pin of pinsRequiringDriver) {
                    const typeName = getPinTypeName(pin.pinType);
                    const message = `${typeName} pin "${formatPinReference(pin)}" is not driven by any output.`;
                    foundProblems.push(createErcProblem(this.problemTypeKey, `${this.problemTypeKey}_${netHash}_${pin.terminalUid}`, message, [pin.elementUid], [formatPinReference(pin)]));
                }
            }
        }
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcUndrivenNetValidator.js.map